module.exports = __webpack_public_path__ + "img/banner-page-visit.531cb7f8.png";